import { fetchCompany } from "@/api";

export default {
  namespaced: true,
  state: () => ({
    info: null,
    loading: false,
    error: null,
  }),
  mutations: {
    SET_LOADING(state, val) {
      state.loading = val;
    },
    SET_INFO(state, data) {
      state.info = data;
      state.error = null;
    },
    SET_ERROR(state, err) {
      state.error = err;
    },
  },
  actions: {
    async fetchCompany({ commit }) {
      commit("SET_LOADING", true);
      try {
        const res = await fetchCompany();
        commit("SET_INFO", res.data.data);
      } catch (err) {
        commit("SET_ERROR", "获取公司信息失败");
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
